import React from 'react';

import { Checkbox } from '@/components/ui/checkbox';
import { CommandGroup, CommandItem } from '@/components/ui/command';
import { AvatarWithName } from '../../../../../../../shared/components/Avatar';
import { useAuth } from '../../../../../../../shared/hooks';
import { useFilters, useResources } from '../../../../hooks';
import NoAssigneeItem from './NoAssigneeItem';

const NO_ASSIGNEE_VALUE = 'null';

const AssigneeList = () => {
  const {
    user: { id: currentUserId },
  } = useAuth();

  const { activeFilters, toggleFilter } = useFilters();
  const { users: assignees } = useResources();

  const buildLabel = (assignee) =>
    currentUserId === assignee.id ? `${assignee.fullName} (me)` : assignee.fullName;

  const isSelected = (value) => activeFilters.assignees.includes(value);

  return (
    <CommandGroup>
      <NoAssigneeItem
        isSelected={isSelected(NO_ASSIGNEE_VALUE)}
        onSelect={() => toggleFilter({ type: 'assignees', value: NO_ASSIGNEE_VALUE })}
      />

      {assignees.map((assignee) => {
        const label = buildLabel(assignee);

        return (
          <CommandItem
            key={assignee.id}
            onSelect={() => toggleFilter({ type: 'assignees', value: assignee.id })}
            value={label}
          >
            <Checkbox checked={isSelected(assignee.id)} />

            <AvatarWithName
              avatarColor={assignee.avatarColor}
              fullName={label}
              initials={assignee.initials}
            />
          </CommandItem>
        );
      })}
    </CommandGroup>
  );
};

export default AssigneeList;
